import React, { Component } from 'react';
import './App.css';
import {Layout, Header, Navigation, Content,Grid,Cell,Drawer} from 'react-mdl';
import Main from './Components/Main';
import {Link} from 'react-router-dom';
import { inherits } from 'util';

class App extends Component {
  render() {
    return (
      <div className="demo-big-content">
    <Layout>
        <Header className = 'header-color' title={<Navigation ><Link style={{fontSize:"1em"}} to ="/">Mrityunjoy Nath</Link></Navigation>} scroll>
            <Navigation>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/projects">Projects</Link>
                <Link to="/resume">Resume</Link>
            </Navigation>
        </Header>
        <Drawer title={<Link style={{fontSize:"1em",textDecoration:"none",color:"inherit"}} to ="/">Mrityunjoy</Link>} scroll>
            <Navigation>
                <Link to="/">Home</Link>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/projects">Projects</Link>
                <Link to="/resume">Resume</Link>
            </Navigation>
        </Drawer>
        <Content>
            <div className="page-content" />
            <Main/>
        </Content>
    </Layout>
</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js